import { Button } from '@/_shared/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/_shared/components/ui/dialog';

interface DisconnectClientDialogProps {
  client: { clientId: string; name: string } | null;
  onOpenChange: (open: boolean) => void;
  isDisconnecting: boolean;
  onConfirm: (clientId: string) => void;
}

export function DisconnectClientDialog({
  client,
  onOpenChange,
  isDisconnecting,
  onConfirm,
}: DisconnectClientDialogProps): React.ReactElement {
  return (
    <Dialog
      open={client !== null}
      onOpenChange={(open) => {
        if (!open && !isDisconnecting) onOpenChange(false);
      }}
    >
      <DialogContent
        onEscapeKeyDown={(event) => {
          if (isDisconnecting) event.preventDefault();
        }}
        onInteractOutside={(event) => {
          if (isDisconnecting) event.preventDefault();
        }}
      >
        <DialogHeader>
          <DialogTitle>Disconnect client</DialogTitle>
          <DialogDescription>
            {client
              ? `${client.name} will lose access immediately and will need to reconnect to use your workspace MCP tools.`
              : ''}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            type="button"
            variant="secondary"
            onClick={() => onOpenChange(false)}
            disabled={isDisconnecting}
            label="Cancel"
          />
          <Button
            type="button"
            variant="primary-destructive"
            loading={isDisconnecting}
            onClick={() => client && onConfirm(client.clientId)}
            label="Disconnect"
          />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
